import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Identity Package P5d — what stands where the Order button would be when the
 * guest cannot prove they are in the venue.
 *
 * ONE component, used by the customer card, the browse-only menu and the order
 * screen. Three surfaces can refuse an order, and three hand-written copies of
 * this message would drift — the same reasoning that made `PendingPoints` and
 * `RedeemList` single components.
 *
 * It is deliberately an INSTRUCTION, not an error. The guest did nothing wrong:
 * they opened their own card, or a link they saved. The only thing missing is
 * the one action that proves they are here, so the copy names it and points at
 * the two QRs that actually exist in the room — the table tent and the screen.
 *
 * `expired` swaps the reason line for "your session ended" — a guest who ordered
 * an hour ago and is being told to scan again deserves to know why, or the app
 * looks broken. Both variants ask for the same thing.
 */
export default function ScanToOrder({ expired = false, compact = false }) {
  const { t } = useTranslation();

  return (
    <div className={`ss-gate${compact ? " compact" : ""}`} role="note">
      <span className="ic" aria-hidden="true">📷</span>
      <div className="tx">
        <div className="hi">{t("scan_stay.gate.cta")}</div>
        <div className="sub">{t(expired ? "scan_stay.gate.expired" : "scan_stay.gate.why")}</div>
      </div>
    </div>
  );
}
